import React, { FC, useState, useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import {
	IonHeader,
	IonToolbar,
	IonButtons,
	IonMenuButton,
	IonIcon,
	IonSearchbar,
	IonButton,
} from '@ionic/react';
import { notifications } from 'ionicons/icons';
import classes from './Header.module.css';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import HeaderList from './HeaderList';

interface HeaderProps extends RouteComponentProps {}

const Header: FC<HeaderProps> = (props: any) => {
	const [showHeader, setShowHeader] = useState(true);
	const { location } = props;
	const [searchText, setSearchText] = useState('');
	const [isSearchHidden, setIsSearchHidden] = useState(true);
	const [searchBarValue, setSearchBarValue] = useState('');
	const [hashEventExists, setHashEventExists] = useState(false);

	useEffect(() => {
		if (!hashEventExists && location.pathname.includes('/gobe')) {
			setHashEventExists(true);
			window.addEventListener('hashchange', () => {
				// if we are in the session page (either legacy or new one with hardware acceleration)
				if (window.location.pathname.includes('/gobe/session')) {
					setShowHeader(false);
				} else {
					setShowHeader(true);
				}
			});
		}
	}, [hashEventExists, location.pathname]);

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, false);
		return () => {
			document.removeEventListener('click', handleClickOutside, false);
		};
	}, []);

	const handleClickOutside = (event: any) => {
		if (
			event != null &&
			event.toElement != null &&
			event.toElement.className != null &&
			event.toElement.className !== 'searchbar-input sc-ion-searchbar-md'
		) {
			setIsSearchHidden(true);
			setSearchBarValue('');
		}
	};

	const searchBarOnChange = (e: any) => {
		console.log(e.detail?.value);
		setSearchText(e.detail.value!);

		if (e.detail.value.length >= 3) {
			console.log('show searchbar');
			setIsSearchHidden(false);
			setSearchBarValue(e.detail.value.toLowerCase());
		} else {
			console.log('hide searchbar');
			setIsSearchHidden(true);
		}
	};

	const hide = () => {
		setIsSearchHidden(true);
	};

	const clearText = () => {
		console.log('clearText');
		setSearchBarValue('');
		setSearchText('');
	};

	if (!showHeader) {
		return <div />;
	} else
		return (
			<IonHeader>
				<IonToolbar>
					<IonButtons>
						<IonMenuButton />
						{/* <IonSearchbar
							className={classes.searchBar}
							value={searchText}
							placeholder={props.intl.formatMessage({ id: 'Header.search' })}
							onIonChange={searchBarOnChange}
							// onFocus={e => setIsSearchHidden(false)}
							autocomplete="on"
						/> */}
						<div className={classes.searchBar} />
						{/* <IonButton
							className={classNames(classes.headerBtn, classes.notifHeaderBtn)}
						>
							<IonIcon
								className={classes.headerIcon}
								slot="icon-only"
								size="small"
								icon={notifications}
							/>
							<div className={classes.badge} />
						</IonButton> */}
						<div className={classNames(classes.headerBtn, classes.notifHeaderBtn)} />
						<hr className={classes.verticalDivider} />
						<div className={classes.logo} />
					</IonButtons>
				</IonToolbar>
				{isSearchHidden ? null : (
					<HeaderList
						hideList={isSearchHidden}
						setHideList={hide}
						inputValue={searchBarValue}
						clearText={clearText}
					/>
				)}
			</IonHeader>
		);
};

export default injectIntl(withRouter(Header));
